import { MemoizedSelector, createFeatureSelector } from '@ngrx/store';
import { CHECKOUT_FEATURE, CustomCheckoutState, StateWithCustomCheckout } from '../checkout-state';

export const getCustomCheckoutState: MemoizedSelector<StateWithCustomCheckout, CustomCheckoutState> =
  createFeatureSelector<CustomCheckoutState>(CHECKOUT_FEATURE);
